import { useEffect, useState } from "react";
import Button from "Components/UI/Button";
import Input from "Components/UI/Input";
import { disabledStyle, pdStyles } from "Components/PatentDesign/styles";
import { updatePatentDesignRequest } from "JS/API";
import { designTokens } from "utils/designSystem";
import { ERROR_MESSAGE, NUMBER_MAX_LENGTH } from "utils/patentDesign";

const FIELDS = [
  { key: "application_number", label: "출원번호", type: "text" },
  { key: "application_date", label: "출원일", type: "date" },
  { key: "registration_number", label: "등록번호", type: "text" },
  { key: "registration_date", label: "등록일", type: "date" },
];

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: designTokens.spacing.md,
  marginBottom: designTokens.spacing.md,
};

const ApplicationInfoForm = ({ requestId, application, onReload, onAlert, onError }) => {
  const applicationNumber = application?.application_number || "";
  const applicationDate = application?.application_date?.slice(0, 10) || "";
  const registrationNumber = application?.registration_number || "";
  const registrationDate = application?.registration_date?.slice(0, 10) || "";

  const [form, setForm] = useState({
    application_number: applicationNumber,
    application_date: applicationDate,
    registration_number: registrationNumber,
    registration_date: registrationDate,
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setForm({
      application_number: applicationNumber,
      application_date: applicationDate,
      registration_number: registrationNumber,
      registration_date: registrationDate,
    });
  }, [applicationNumber, applicationDate, registrationNumber, registrationDate]);

  const saved = {
    application_number: applicationNumber,
    application_date: applicationDate,
    registration_number: registrationNumber,
    registration_date: registrationDate,
  };
  const isDirty = FIELDS.some(({ key }) => form[key] !== saved[key]);
  const isSaveDisabled = isSaving || !isDirty;

  const handleSave = async () => {
    if (isSaveDisabled) return;
    setIsSaving(true);
    try {
      const changes = {};
      FIELDS.forEach(({ key, type }) => {
        if (form[key] === saved[key]) return;
        changes[key] = type === "text" ? form[key].trim() || null : form[key] || null;
      });
      const result = await updatePatentDesignRequest(requestId, changes);
      if (result && typeof result === "object") {
        onAlert("출원 정보를 저장했습니다.");
        onReload();
      } else if (ERROR_MESSAGE[result]) {
        onAlert(ERROR_MESSAGE[result]);
      } else {
        onError(result);
      }
    } catch {
      onError();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <div style={gridStyle}>
        {FIELDS.map(({ key, label, type }) => (
          <div key={key}>
            <label htmlFor={`patent-design-${key}`} style={pdStyles.label}>
              {label}
            </label>
            <Input
              id={`patent-design-${key}`}
              type={type}
              maxLength={type === "text" ? NUMBER_MAX_LENGTH : undefined}
              value={form[key]}
              onChange={(e) => setForm((prev) => ({ ...prev, [key]: e.target.value }))}
            />
          </div>
        ))}
      </div>
      <Button
        variant="secondary"
        onClick={handleSave}
        disabled={isSaveDisabled}
        style={disabledStyle(isSaveDisabled)}
      >
        출원 정보 저장
      </Button>
    </div>
  );
};

export default ApplicationInfoForm;
